<template>
  <div id="app">
    <Navigation
      :class='{"navigation--scrolled": isScrolled,
                "navigation--scrolled-perm": nav_perm_scrolled}'></Navigation>
    <router-view @makeScrolled="makeScrolled"></router-view>
    <Footer />
  </div>
</template>

<script>
import Navigation from './components/Navigation'
import Footer from './components/Footer'

export default {
  name: 'home',
  components: { Navigation, Footer },
  data () {
    return {
      nav_perm_scrolled: false,
      scrolled: false
    }
  },
  methods: {
    makeScrolled () {
      this.nav_perm_scrolled = true;
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      let scroll_pos = window.scrollY;
      if (scroll_pos>=150) this.scrolled = true
      else this.scrolled = false;
    })
  },
  computed: {
    isScrolled () {
      if (this.nav_perm_scrolled === true) return true;
      else if (this.scrolled === true) return true;
    }
  }
}
</script>
<style lang="scss">
#app {
  background: #F5F5F5;
  font-family: 'Maven Pro', sans-serif;
  // font-size: 18px;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
